import { native } from "./native/client.mjs";
export const go = {
    info: {
        key: 'go',
        title: 'Go',
        extname: '.go',
        default: 'native',
    },
    clientsById: {
        native,
    },
};
